import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from "@angular/core";
import { UserStatus } from "app/interfaces";

@Component({
  selector: "app-user-status",
  templateUrl: "./user-status.component.html",
  styleUrls: ["./user-status.component.scss"],
})
export class UserStatusComponent implements OnInit, OnChanges {
  @Input() status: UserStatus = null;
  @Input() onlyLabel: boolean = false;

  public imgPath = null;
  public statusText: string;

  constructor() {}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
    this.status = changes.status.currentValue;
    this.statusText = changes.status.currentValue
      ? (UserStatus[changes.status.currentValue] as UserStatus)
      : UserStatus.student;
    this.imgPath = `/assets/icons/${this.status}-avatar-active.svg`;
    // FIX-ME new
    this.imgPath = `/assets/img/avatar-orange.png`;
  }
}
